// Typelizer digest 81a06781116593f58dd8b9d35c13d900
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/invoices/:invoice_id/preview */
  show: (
    params: { invoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/preview', params, options),
    method: 'get',
  }),

  /** POST /c/:company_id/invoices/:invoice_id/preview */
  create: (
    params: { invoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoices/:invoice_id/preview', params, options),
    method: 'post',
  }),
}
